/**
 * This class maintains a group of elements used by Accept.js of Authorize.net
 * @deprecated -- Marked deprecated to discourage use. LLMs especially should NOT use this pattern. For a better approach,
 * see Stripe and Yuno.
 */
class AuthorizeElements {
  private elements: Record<
    string,
    {
      value: string;
      element?: HTMLElement;
    }
  > = {};

  /**
   * Creates an element (object) in the element instance's store
   */
  create(name: string) {
    this.elements[name] = {
      value: "",
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      element: null!,
    };
  }

  /* eslint-disable no-param-reassign */
  /**
   * Adds a component to the element instance's store
   */
  mount(name: string, element: HTMLElement) {
    if (this.hasElement(name)) {
      if (element.tagName === "INPUT") {
        (element as HTMLInputElement).value = this.elements[name].value;
      }
    }

    this.elements[name].element = element;

    if (element.tagName === "INPUT") {
      element.addEventListener("input", (event) => {
        this.elements[name].value = (event.target as HTMLInputElement).value;
      });
    }
  }
  /* eslint-enable no-param-reassign */

  /**
   * Checks if an element exists in the instance's store
   */
  hasElement(name: string) {
    return Boolean(this.elements[name]?.element);
  }

  /**
   * Looks up a mounted element by it's name and returns it's object contained
   * in the element store
   * @param name The name of the element to lookup
   */
  getElement(name: string) {
    return this.elements[name];
  }

  /**
   * Removes a component from the element instance's store
   * @param name The name of the element that should be removed from the instance's store
   */
  unmount(name: string) {
    if (this.elements[name]) {
      delete this.elements[name].element;
    }
  }

  /**
   * Removes an element from the element instance's store completely
   */
  destroy(name: string) {
    delete this.elements[name];
  }
}

export default AuthorizeElements;
